// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"
import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"
// Redux
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap"
import LOGO from "../../assets/images/logo_mesa_servicio.png"
import ApiRest from "../../ayudas/apiRest"
// actions
import { apiError, loginUser, socialLogin } from "../../store/actions"


const Login = (props) => {

    const apiRest = new ApiRest(props);
    const [hayError, setHayError] = useState(false);

    const generateError = () => {
        setHayError(true);
        setTimeout(() => setHayError(false), 3000);
    }

    const calificar =  (id) =>{
        apiRest.get('/calificarSolicitudesAutomaticas/'+id).then(res => {
            if(res.exitoso){
                console.log(res);
            }
        })
    }

    // handleValidSubmit
    const handleValidSubmit = (event, values) => {
        //sessionStorage.setItem("values", JSON.stringify(values));
        
        apiRest.postSinToken('/token/', values).then(resultado => {
            if (resultado.exitoso) {
                props.loginUser(values, props.history);
                apiRest.setLS("authUser", resultado.data);
                apiRest.get('/usuarioDatosIniciales').then(resultado => {
                    if (resultado.exitoso) {
                        if(resultado.data.colaborador !== undefined && resultado.data.colaborador !== null){
                            //calificar(resultado.data.colaborador.id);
                        }
                        apiRest.setLS('du', resultado.data);
                        if(apiRest.getRol()){
                            apiRest.asignarEmpresa('idEmpresa',null);
                        }else{
                            let usuario = apiRest.getLS('du');
                            apiRest.asignarEmpresa('idEmpresa',usuario.usuario_empresas[0]);
                        }
                        /*apiRest.postVerificarSolicitud();
                        let minuto = 1000 * 60;
                        setInterval(function(){
                            apiRest.postVerificarSolicitud();
                        },  1000 *10);*/
                        
                        /*apiRest.tienePermiso('item_solicitud_nueva')
                            ? props.history.push("/solicitud")
                            : props.history.push("/dashboard");*/
                        props.history.push("/dashboard");
                    } else {
                        generateError();
                    }
                });
            } else {
                generateError();
            }
        }).catch(error => {
            console.error('Error:', error);
            generateError();
        });
    }

    useEffect(() => {
        document.body.className = "authentication-bg";
        // remove classname when component will unmount
        return function cleanup() {
            document.body.className = "";
        };
    });

    return (
        <React.Fragment>
            <div className="account-pages my-2 pt-sm-2">
                <Container>
                    <Row className="align-items-center justify-content-center">
                        <Col lg={5}>
                            <div className="text-center">
                                <Link to="/" className="mb-5 d-block auth-logo">
                                    <img src={LOGO} alt="" width="60%" className="logo logo-dark" />
                                </Link>
                            </div>
                        </Col>
                    </Row>
                    <Row className="align-items-center justify-content-center">
                        {hayError && <Alert color="danger">Error, por favor intente de nuevo.</Alert>}
                        <Col md={8} lg={6} xl={5}>
                            <Card>
                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        <h5 className="text-primary">Mesa de Servicio</h5>
                                        <p className="text-muted">Ingresa tus datos para continuar.</p>
                                    </div>
                                    <div className="p-2 mt-4">
                                        <AvForm
                                            className="form-horizontal"
                                            onValidSubmit={(e, v) => {
                                                handleValidSubmit(e, v)
                                            }}
                                        >
                                            {props.error && typeof props.error === "string" ? (
                                                <Alert color="danger">{props.error}</Alert>
                                            ) : null}

                                            <div className="mb-3">
                                                <AvField
                                                    name="username"
                                                    label="Usuario"
                                                    className="form-control"
                                                    placeholder="Ingresar usuario"
                                                    type="text"
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <AvField
                                                    name="password"
                                                    label="Contraseña"
                                                    type="password"
                                                    required
                                                    placeholder="Ingresar contraseña"
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <button className="btn btn-primary w-100 waves-effect waves-light" type="submit">
                                                    Ingresar
                                                </button>
                                                
                                                <div className="text-center mt-2">
                                                    <br></br>
                                                    <Link to="/forgot-password" className="text-muted">Olvido su Contraseña?</Link>
                                                </div>
                                            </div>
                                        </AvForm>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="mt-5 text-center whiteColor">
                                <p>© {new Date().getFullYear()} Xelapan</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    const { error } = state.Login
    return { error }
}

export default withRouter(
    connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login)
)

Login.propTypes = {
    error: PropTypes.any,
    history: PropTypes.object,
    loginUser: PropTypes.func,
    socialLogin: PropTypes.func
}